import UptimeInlineSummary from "@/v2-backoffice-client/uptime/inline/UptimeInlineSummary"
import { useLayerUptime } from "@/v2-backoffice-client/layer/LayerUptimeMapContext"

export type LayerUptimeCellProps = {
  featureCode: string | null | undefined
}

// One-row binding for the layer table's "Uptime" column. Reads from
// the shared context populated by `LayerUptimeMapProvider` so the
// list query only fires once per mount of the table.
function LayerUptimeCell(props: Readonly<LayerUptimeCellProps>) {
  const { target, loading } = useLayerUptime(props.featureCode)
  return (
    <UptimeInlineSummary target={target} loading={loading} variant="cell" />
  )
}

export default LayerUptimeCell
